import { qcAxios } from './axiosQcClient';

const API_PREFIX = '/api';

export const submitSegments = async ({ assignmentId, segments, transcript, comment }) => {
  const response = await qcAxios.post(`${API_PREFIX}/assignmentData/submitSegments`, {
    assignmentId,
    segments,
    status: 'SUBMITTED',
    transcript,
    comment,
  });
  return response?.data;
};

export const submitAnnotations = async ({ assignmentId, segments, transcript, comment }) => {
  const response = await qcAxios.post(`${API_PREFIX}/assignmentData/submitAnnotations`, {
    assignmentId,
    segments,
    status: 'SUBMITTED',
    transcript,
    comment,
  });
  return response?.data;
};

export const saveSegmentsLater = async ({ assignmentId, segments, transcript, comment }) => {
  const response = await qcAxios.post(`${API_PREFIX}/assignmentData/saveSegmentsLater`, {
    assignmentId,
    segments,
    transcript,
    comment,
  });
  return response?.data;
};

export const getSegments = async ({ assignmentId }) => {
  const response = await qcAxios.get(`${API_PREFIX}/assignmentData/getSegments`, {
    params: { assignmentId },
  });
  return response?.data;
};

export const reviewSegmentation = async ({ assignmentId, status, segments, transcript, comment, questions }) => {
  const hasPayload = segments !== undefined || transcript !== undefined || comment !== undefined || questions !== undefined;
  const response = await qcAxios.post(
    `${API_PREFIX}/assignmentData/submitAssignedRequests`,
    hasPayload ? { response: { segments, updated_vendor_transcript: transcript, comment, questions } } : {},
    { params: { assignmentId, reqStatus: status } },
  );
  return response?.data;
};
